export enum AssetContentType {
    applicationP12 = 'application/x-pkcs12',
    applicationPdf = 'application/pdf',
    doc = 'application/msword',
    docx = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    imageHeic = 'image/heic',
    imageHeif = 'image/heif',
    imageJpeg = 'image/jpeg',
    imageJpg = 'image/jpg',
    imagePng = 'image/png',
    imageTif = 'image/tif',
    imageTiff = 'image/tiff',
    mov = 'video/quicktime',
    mp4 = 'video/mp4',
    ppt = 'application/vnd.ms-powerpoint',
    pptx = 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    xls = 'application/vnd.ms-excel',
    xlsx = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
}
